/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  's-maintain': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M10 0C4.48 0 0 4.48 0 10s4.48 10 10 10 10-4.48 10-10S15.52 0 10 0zm4.754 14.154l-.6.6a.847.847 0 01-1.193 0l-2.657-2.661a.418.418 0 00-.458-.09A4.01 4.01 0 014.93 6.126l2.26 2.26a.207.207 0 00.179.058l.786-.11a.21.21 0 00.178-.18l.11-.785a.207.207 0 00-.056-.179L6.125 4.93a4.014 4.014 0 015.879 4.917.418.418 0 00.089.458l2.66 2.657a.847.847 0 010 1.193z" _fill="#f7ba1e"/>'
  }
})
